export const categoryLevels = [
  {
    category: "RC",
    name: "Receptive Language",
    levels: [
      { level: 1, maxLevel: 12 },
      { level: 2, maxLevel: 26 },
      { level: 3, maxLevel: 37 },
      { level: 4, maxLevel: 45 }
    ]
  },
  {
    category: "EC",
    name: "Expressive Language",
    levels: [
      { level: 1, maxLevel: 20 },
      { level: 2, maxLevel: 33 },
      { level: 3, maxLevel: 40 },
      { level: 4, maxLevel: 45 }
    ]
  },
  {
    category: "CS",
    name: "Cognitive Skills",
    levels: [
      { level: 1, maxLevel: 9 },
      { level: 2, maxLevel: 22 },
      { level: 3, maxLevel: 32 },
      { level: 4, maxLevel: 45 }
    ]
  },
  {
    category: "GM",
    name: "Gross Motor",
    levels: [
      { level: 1, maxLevel: 7 },
      { level: 2, maxLevel: 17 },
      { level: 3, maxLevel: 29 },
      { level: 4, maxLevel: 45 }
    ]
  },
  {
    category: "FM",
    name: "Fine Motor",
    levels: [
      { level: 1, maxLevel: 6 },
      { level: 2, maxLevel: 23 },
      { level: 3, maxLevel: 30 },
      { level: 4, maxLevel: 45 }
    ]
  },
  {
    category: "ADL",
    name: "Activities of Daily Living",
    levels: [
      { level: 1, maxLevel: 9 },
      { level: 2, maxLevel: 22 },
      { level: 3, maxLevel: 31 },
      { level: 4, maxLevel: 45 }
    ]
  },
  {
    category: "SE",
    name: "Social Emotional",
    levels: [
      { level: 1, maxLevel: 24 },
      { level: 2, maxLevel: 30 },
      { level: 3, maxLevel: 36 },
      { level: 4, maxLevel: 45 }
    ]
  },
  {
    category: "PB",
    name: "Play Behaviour",
    levels: [
      { level: 1, maxLevel: 11 },
      { level: 2, maxLevel: 21 },
      { level: 3, maxLevel: 33 },
      { level: 4, maxLevel: 45 }
    ]
  }
];

export const levelColors = {
    1: '#386227', // green
    2: '#f4932b', // orange
    3: '#007ec8', // blue
    4: '#ff0000', // red
  };

/**
 * Generic helper to calculate domain progress
 */
function calculateProgress(levels, achieved) {
  for (let i = 0; i < levels.length; i++) {
    const lvl = levels[i];
    const prevMax = i > 0 ? levels[i - 1].maxLevel : 0;
    if (achieved <= lvl.maxLevel) {
      const currentProgress = achieved - prevMax;
      const levelRange = lvl.maxLevel - prevMax;
      return {
        level: lvl.level,
        maxLevel: lvl.maxLevel,
        percentage: ((currentProgress / levelRange) * 100).toFixed(2)
      };
    }
  }
  // if achieved is beyond all levels → clamp to last
  const last = levels[levels.length - 1];
  return {
    level: last.level,
    maxLevel: last.maxLevel,
    percentage: "100.00"
  };
}

/**
 * Get progress by domain code (e.g. "GM")
 */
export function getDomainProgress(domainCode, achieved) {
  const domainConfig = categoryLevels.find(c => c.category === domainCode);
  if (!domainConfig) return null;
  return calculateProgress(domainConfig.levels, achieved);
}

/**
 * Get progress by domain name (e.g. "Receptive Language")
 */
export function getDomainProgressbyName(domainName, achieved) {
  const domainConfig = categoryLevels.find(c => c.name === domainName);
  if (!domainConfig) return null;
  return calculateProgress(domainConfig.levels, achieved);
}

/**
 * Get full distribution for a domain by achieved skills
 * Returns an object: {1: %, 2: %, 3: %, 4: %}
 */
export function getDomainLevelDistribution(domainName, achieved) {
  const domainConfig = categoryLevels.find(c => c.name === domainName);
  if (!domainConfig) return {};

  const levels = domainConfig.levels;
  const dist = {};

  for (let i = 0; i < levels.length; i++) {
    const lvl = levels[i];
    const prevMax = i > 0 ? levels[i - 1].maxLevel : 0;
    const levelRange = lvl.maxLevel - prevMax;

    if (achieved >= lvl.maxLevel) {
      // fully completed this level
      dist[lvl.level] = 100;
    } else if (achieved > prevMax) {
      // partially completed this level
      const currentProgress = achieved - prevMax;
      dist[lvl.level] = (currentProgress / levelRange) * 100;
    } else {
      // not started this level
      dist[lvl.level] = 0;
    }
  }

  return dist;
}